<template>
  <div class="middle-menus">
      <div class="middle-menu" v-for="(item, index) in menus" :key="index" @click='goto(item)'>
          <img :src="item.icon" alt="">
          <p>{{item.mname}}</p>
      </div>
  </div>
</template>

<script>
import MenuIcon1 from '@/assets/img/menu-icon-1.png'
import MenuIcon2 from '@/assets/img/menu-icon-2.png'
import MenuIcon3 from '@/assets/img/menu-icon-3.png'
import MenuIcon4 from '@/assets/img/menu-icon-4.png'
import MenuIcon5 from '@/assets/img/menu-icon-5.png'
import { menulist } from '@/api/header.js'
export default {
  name: 'MiddleMenu',
  data () {
    return {
      menus: [
        {
          name: '极地探险',
          icon: MenuIcon1,
          goto: ''
        },
        {
          name: '极地探险',
          icon: MenuIcon2,
          goto: ''
        },
        {
          name: '极地探险',
          icon: MenuIcon3,
          goto: ''
        },
        {
          name: '极地探险',
          icon: MenuIcon4,
          goto: ''
        },
        {
          name: '极地探险',
          icon: MenuIcon5,
          goto: ''
        },
        {
          name: '极地探险',
          icon: MenuIcon5,
          goto: ''
        }
      ]
    }
  },
  methods: {
    getmenulist () {
      menulist({page: 1, limit: 1000, isshow: true, sort: 'orderNo', order: 'asc'}).then(res => {
        this.menus = res.data.data.items
      })
    },
    goto (item) {
      this.$router.push({
        path: item.url,
        query: {
          id: item.id,
          img: item.topimg,
          name: item.mname
        }
      })
    }
  },
  created () {
    this.getmenulist()
  }
}
</script>

<style lang="scss" scoped>
.middle-menus {
    width: 1232px;
    height: 185px;
    background: url(../../assets/img/menus-bg.png);
    margin: -50px auto 0;
    position: relative;
    z-index: 1020;
    display: flex;
    .middle-menu {
        height: 187px;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        text-decoration: none;
        cursor: pointer;
        &:nth-child(1) {
            width: 198px;
        }
        &:nth-child(2) {
            width: 210px;
        }
        &:nth-child(3) {
            width: 208px;
        }
        &:nth-child(4) {
            width: 210px;
        }
        &:nth-child(5) {
            width: 210px;
        }
        &:nth-child(6) {
            width: 196px;
        }
        p {
            margin-top: 20px;
            font-size: 18px;
            font-weight:300;
            color: #fff;
        }
        img {
            width: 54px;
            height: 60px;
            transition: 0.3s all;
        }
        &:hover img{
            transition: 0.3s all;
            margin-top: -10px;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/views/Index/menu.vue